import React from 'react'
import {Icon} from '@chakra-ui/react'

const CompareIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            {/* <path
                d="M20.4235 31.6311H9.42212C7.53318 31.6311 6 30.0979 6 28.209V11.4033C6 9.51438 7.53318 7.9812 9.42212 7.9812H20.3727"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.5625 31.6277H31.3757C33.2477 31.6277 34.7724 30.1199 34.7978 28.2479"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M34.7959 23.2V16.8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M34.7997 11.4172C34.7997 9.51133 33.2665 7.97815 31.3776 7.97815H28.6152"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.4248 4V36"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.3992 16.8L25.1992 20L28.3992 23.2"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.3996 16.8L15.5996 20L12.3996 23.2"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            /> */}
            <path
                d="M20.1531 33.9385H7.78713C5.14531 33.9385 3 31.7932 3 29.1513V10.2558C3 7.61394 5.14531 5.46863 7.78713 5.46863H20.0969C20.6121 5.46863 21.0337 5.8902 21.0337 6.40544C21.0337 6.92069 20.6121 7.34226 20.0969 7.34226H7.78713C6.18517 7.34226 4.87363 8.64443 4.87363 10.2558V29.1513C4.87363 30.7533 6.17581 32.0648 7.78713 32.0648H20.1531C20.6684 32.0648 21.0899 32.4864 21.0899 33.0017C21.0899 33.5169 20.6684 33.9385 20.1531 33.9385Z"
                fill="currentColor"
            />
            <path
                d="M32.4636 33.9291H29.2972C28.7819 33.9291 28.3604 33.5076 28.3604 32.9923C28.3604 32.4771 28.7819 32.0555 29.2972 32.0555H32.4636C34.0468 32.0555 35.349 30.7627 35.3771 29.1795C35.3771 28.6642 35.8361 28.252 36.3233 28.252C36.8385 28.252 37.2507 28.6829 37.2507 29.1982C37.2133 31.8025 35.068 33.9198 32.4636 33.9198V33.9291Z"
                fill="currentColor"
            />
            <path
                d="M36.3128 24.4578C35.7975 24.4578 35.376 24.0363 35.376 23.521V16.3263C35.376 15.811 35.7975 15.3895 36.3128 15.3895C36.828 15.3895 37.2496 15.811 37.2496 16.3263V23.521C37.2496 24.0363 36.828 24.4578 36.3128 24.4578Z"
                fill="currentColor"
            />
            <path
                d="M36.3128 11.2113C35.7975 11.2113 35.376 10.7897 35.376 10.2745C35.376 8.66317 34.0738 7.34226 32.4625 7.34226H29.3616C28.8464 7.34226 28.4248 6.92069 28.4248 6.40544C28.4248 5.8902 28.8464 5.46863 29.3616 5.46863H32.4625C35.1043 5.46863 37.2496 7.6233 37.2496 10.2745C37.2496 10.7897 36.828 11.2113 36.3128 11.2113Z"
                fill="currentColor"
            />
            <path
                d="M20.1526 38.8474C19.6374 38.8474 19.2158 38.4258 19.2158 37.9106V1.93682C19.2158 1.42157 19.6374 1 20.1526 1C20.6679 1 21.0895 1.42157 21.0895 1.93682V37.9106C21.0895 38.4258 20.6679 38.8474 20.1526 38.8474Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CompareIcon
